// lib
import { call } from 'redux-saga/effects'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export function* updateSourcesSaga(schema, surveys) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const updateSourceURL = staticStore.urls.updateSource
  if (!updateSourceURL) {
    throw new Error('No "updateSource" endpoint URL')
  }
  const response = yield call(railsPostFetch, updateSourceURL, {
    body: JSON.stringify({ schema: schema.toJS(), surveys })
  })
  if (!response.ok) {
    throw new Error(response.error || 'Error updating sources')
  }
  const body = yield call([response, 'json'])
  if (!body.status) {
    throw new Error('Error updating sources')
  }
  return body
}

export function* updateBlock_Saga(blockModel, currentBlockUID) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const updateBlockURL = staticStore.urls.updateBlock
  if (!updateBlockURL) {
    throw new Error('No "updateBlock" endpoint URL')
  }
  const response = yield call(railsPostFetch, updateBlockURL, {
    body: JSON.stringify({ block: blockModel.toJS(), currentBlockUID })
  })
  if (!response.ok) {
    throw new Error(response.error || 'Error updating block')
  }
  const body = yield call([response, 'json'])
  if (!body.status) {
    throw new Error('Update block request failed')
  }
  return body
}

export function* updateBlocks_Saga(blocksList, currentBlockUID) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const updateBlocksURL = staticStore.urls.updateBlocks
  if (!updateBlocksURL) {
    throw new Error('No "updateBlocks" endpoint URL')
  }
  const response = yield call(railsPostFetch, updateBlocksURL, {
    body: JSON.stringify({ blocks: blocksList.map(block => block.toJS()).toArray(), currentBlockUID })
  })
  if (!response.ok) {
    throw new Error(response.error || 'Error updating blocks')
  }
  const body = yield call([response, 'json'])
  if (!body.status) {
    throw new Error('Update blocks request failed')
  }
  return body
}

export function* updateSchemaSaga(schemaModel, surveys) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const updateSchemaURL = staticStore.urls.updateSchema
  if (!updateSchemaURL) {
    throw new Error('No "updateSchema" endpoint URL')
  }
  const response = yield call(railsPostFetch, updateSchemaURL, {
    body: JSON.stringify({ schema: schemaModel.toJS(), surveys })
  })
  if (!response.ok) {
    throw new Error(response.error || 'Error updating schema')
  }
  const body = yield call([response, 'json'])
  if (body.status) {
    return body
  }
  throw new Error('Updating schema request failed')
}
